import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  getWebPageLink,
  WebPageLink,
  WebPageType,
} from '../constants/webPageType';
import { useShareData } from '../context';
import { useSessionStore } from '../stores/SessionStore';
import { useUserStore } from '../stores/UserStore';

const useRedirectEntry = ({
  webPageType = WebPageType.JOYAJOY,
  allowTrial = true,
}: { webPageType?: WebPageType; allowTrial?: boolean } = {}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSharedData } = useShareData();
  const activeUserId = useSessionStore((store) => store.activeUserId);
  const userProfile = useUserStore((store) =>
    store.getProfile(activeUserId ?? ''),
  );

  useEffect(() => {
    if (!activeUserId || !userProfile) {
      setSharedData({
        pathName: location.pathname,
      });
    }
  }, [activeUserId, location.pathname, setSharedData, userProfile]);

  useEffect(() => {
    if (!activeUserId || !userProfile) {
      navigate(getWebPageLink(webPageType, WebPageLink.Entry), {
        replace: true,
      });
    } else if (!allowTrial && userProfile.isTrialUser) {
      navigate(getWebPageLink(webPageType, WebPageLink.Register), {
        replace: true,
      });
    }
  }, [activeUserId, allowTrial, navigate, userProfile, webPageType]);
};

export default useRedirectEntry;
